var map = {
	"./empresa-white-label-logo-5cd49411d28021000c09e013.svg": "./static/icones/empresa-white-label-logo-5cd49411d28021000c09e013.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./static/icones sync recursive ^\\.\\/empresa\\-white\\-label\\-logo\\-.*\\.svg$";